import { Injectable } from '@angular/core';
import { Chart, ChartTypeRegistry, Plugin } from 'chart.js';


@Injectable({
    providedIn: 'root'
})
export class GetChartJSCenterTextPluginService {
    public getChartJSCenterTextPlugin<TType extends keyof ChartTypeRegistry = keyof ChartTypeRegistry>(text: string, color: string, sidePadding: number): Plugin<TType> {
        return {
            id: 'centerText',
            beforeDraw: function (chart: Chart) {
                var ctx = chart.ctx;
                ctx.font = "16px " + Chart.defaults.font.family;

                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                var centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
                var centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2);
                ctx.fillStyle = color;

                ctx.fillText(text, centerX, centerY);
            }
        };
    }
}
